module.exports = __webpack_public_path__ + "media/images/login-3b74b204.svg";